(function () {
  if (!window.CfonElements) return;

  function ensureMaps(key) {
    if (window.__cfonMapsPromise) return window.__cfonMapsPromise;
    window.__cfonMapsPromise = new Promise(function (resolve, reject) {
      window.__cfonMapsReady = function () {
        resolve(window.google.maps);
      };
      var s = document.createElement('script');
      s.src =
        'https://maps.googleapis.com/maps/api/js?v=weekly&loading=async&language=en&region=US' +
        '&callback=__cfonMapsReady&key=' +
        encodeURIComponent(key);
      s.async = true;
      s.onerror = function () {
        reject(new Error('cfon-maps-load-failed'));
      };
      document.head.appendChild(s);
    });
    return window.__cfonMapsPromise;
  }

  function toRad(d) {
    return (d * Math.PI) / 180;
  }

  function haversine(aLat, aLng, bLat, bLng) {
    var dLat = toRad(bLat - aLat);
    var dLng = toRad(bLng - aLng);
    var h =
      Math.sin(dLat / 2) ** 2 +
      Math.cos(toRad(aLat)) * Math.cos(toRad(bLat)) * Math.sin(dLng / 2) ** 2;
    return 2 * 3958.8 * Math.asin(Math.sqrt(h));
  }

  function parseCoord(value) {
    var n = Number(value);
    if (!Number.isFinite(n)) return null;
    return n;
  }

  function normalizeStore(raw, index) {
    if (!raw || typeof raw !== 'object') return null;
    var lat = parseCoord(raw.lat);
    var lng = parseCoord(raw.lng);
    if (lat != null && (lat < -90 || lat > 90)) lat = null;
    if (lng != null && (lng < -180 || lng > 180)) lng = null;

    var zip = raw.zip == null ? '' : String(raw.zip).trim();
    if (zip) zip = zip.padStart(5, '0').slice(0, 5);

    var formats = raw.formats;
    if (!Array.isArray(formats)) formats = [];

    return {
      id: raw.id != null ? String(raw.id) : 'store-' + index,
      name: raw.name != null ? String(raw.name) : '',
      address: raw.address != null ? String(raw.address) : '',
      city: raw.city != null ? String(raw.city) : '',
      state: raw.state != null ? String(raw.state) : '',
      zip: zip,
      lat: lat,
      lng: lng,
      phone: raw.phone != null ? String(raw.phone) : '',
      url: raw.url != null ? String(raw.url) : '',
      formats: formats,
    };
  }

  function geocodePromise(geocoder, request) {
    return new Promise(function (resolve, reject) {
      geocoder.geocode(request, function (results, status) {
        if (status === 'OK' && results && results[0]) {
          resolve(results[0]);
          return;
        }
        var err = new Error(status || 'GEOCODE_FAILED');
        err.code = status;
        reject(err);
      });
    });
  }

  // data-*={{ value | json }} puts JSON unicode escapes in HTML attrs literally.
  // | t may also emit &#39; before | json turns & into \u0026.
  function readJsonDataString(el, attrName, fallback) {
    var raw = el.getAttribute(attrName);
    if (raw == null || raw === '') return fallback || '';
    var value = raw;
    if (value.indexOf('\\u') !== -1) {
      try {
        value = JSON.parse('"' + value.replace(/"/g, '\\"') + '"');
      } catch (error) {
        /* keep value */
      }
    }
    if (value.indexOf('&') !== -1) {
      var ta = document.createElement('textarea');
      ta.innerHTML = value;
      value = ta.value;
    }
    return value;
  }

  class CfonStoreLocator extends CfonElements.Component {
    onConnect() {
      if (this.dataset.state === 'unconfigured') return;

      this.form = this.querySelector('[data-search-form]');
      this.input = this.querySelector('[data-search-input]');
      this.geoBtn = this.querySelector('[data-geolocate]');
      this.moreBtn = this.querySelector('[data-show-more]');
      this.list = this.querySelector('[data-list]');
      this.mapEl = this.querySelector('[data-map]');
      this.template = this.querySelector('[data-store-template]');
      this.statusEl = this.querySelector('[data-status]');
      this.resultsHeading = this.querySelector('[data-results-heading]');
      this.resultsCount = this.querySelector('[data-results-count]');
      this.emptyHeading = this.querySelector('[data-empty-heading]');
      this.emptyBody = this.querySelector('[data-empty-body]');
      this.errorHeading = this.querySelector('[data-error-heading]');
      this.errorBody = this.querySelector('[data-error-body]');

      this.apiKey = this.dataset.apiKey || '';
      this.storesUrl = this.dataset.storesUrl || '';
      this.radius = this.numAttr('radius', 50);
      this.perPage = this.numAttr('perPage', 5);
      this.country = this.dataset.country || 'US';
      this.strDistance = readJsonDataString(this, 'data-str-distance', '%% mi');
      this.strCountOne = readJsonDataString(this, 'data-str-count-one', '%% store near you');
      this.strCountOther = readJsonDataString(this, 'data-str-count-other', '%% stores near you');
      this.strSearching = readJsonDataString(this, 'data-str-searching', '');
      this.strLocating = readJsonDataString(this, 'data-str-locating', '');
      this.strNoMatch = readJsonDataString(this, 'data-str-no-match', '');
      this.strNoResults = readJsonDataString(this, 'data-str-no-results', '');
      this.strErrorTitle = readJsonDataString(this, 'data-str-error-title', '');
      this.strErrorBody = readJsonDataString(this, 'data-str-error-body', '');
      this.strGeoDenied = readJsonDataString(this, 'data-str-geo-denied', '');
      this.strDirectionsFor = readJsonDataString(this, 'data-str-directions-for', '');
      this.strGetDirections = readJsonDataString(this, 'data-str-get-directions', '');
      this.emptyTitle = readJsonDataString(this, 'data-empty-title', '');
      this.emptyBodyText = readJsonDataString(this, 'data-empty-body', '');

      this.stores = null;
      this.storesPromise = null;
      this.results = [];
      this.visible = 0;
      this.markers = [];
      this.map = null;
      this.geocoder = null;
      this.center = null;
      this.activeIndex = -1;
      this.loading = false;
      this.destroyed = false;
      this.abort = new AbortController();
      this.mapsWarmed = false;

      this.onSubmit = this.onSubmit.bind(this);
      this.onGeoClick = this.onGeoClick.bind(this);
      this.onShowMore = this.onShowMore.bind(this);
      this.onListClick = this.onListClick.bind(this);
      this.onFocusIn = this.onFocusIn.bind(this);

      if (this.form) this.form.addEventListener('submit', this.onSubmit);
      if (this.geoBtn) this.geoBtn.addEventListener('click', this.onGeoClick);
      if (this.moreBtn) this.moreBtn.addEventListener('click', this.onShowMore);
      if (this.list) this.list.addEventListener('click', this.onListClick);
      this.addEventListener('focusin', this.onFocusIn, { once: true });
    }

    onDisconnect() {
      this.destroyed = true;
      if (this.abort) this.abort.abort();
      if (this.form) this.form.removeEventListener('submit', this.onSubmit);
      if (this.geoBtn) this.geoBtn.removeEventListener('click', this.onGeoClick);
      if (this.moreBtn) this.moreBtn.removeEventListener('click', this.onShowMore);
      if (this.list) this.list.removeEventListener('click', this.onListClick);
      this.removeEventListener('focusin', this.onFocusIn);
      this.clearMarkers();
      this.map = null;
      this.geocoder = null;
    }

    onFocusIn() {
      if (this.mapsWarmed || !this.apiKey) return;
      this.mapsWarmed = true;
      ensureMaps(this.apiKey).catch(function () {});
    }

    setState(state) {
      this.dataset.state = state;
    }

    setLoading(isLoading) {
      this.loading = isLoading;
      this.classList.toggle('is-loading', isLoading);
      this.setAttribute('aria-busy', isLoading ? 'true' : 'false');
      var loadingEl = this.querySelector('[data-loading]');
      if (loadingEl) {
        loadingEl.setAttribute('aria-hidden', isLoading ? 'false' : 'true');
      }
    }

    announce(text) {
      if (!this.statusEl) return;
      this.statusEl.setAttribute('aria-hidden', 'false');
      this.statusEl.textContent = text || '';
      var el = this.statusEl;
      setTimeout(function () {
        el.setAttribute('aria-hidden', 'true');
      }, 1000);
    }

    focusHeading(el) {
      if (!el) return;
      el.focus({ preventScroll: false });
    }

    reducedMotion() {
      return (
        (window.CfonElements && typeof window.CfonElements.prefersReducedMotion === 'function'
          ? window.CfonElements.prefersReducedMotion()
          : false) || window.matchMedia('(prefers-reduced-motion: reduce)').matches
      );
    }

    loadStores() {
      if (this.storesPromise) return this.storesPromise;
      var self = this;
      this.storesPromise = (async function () {
        var payload = null;
        var inline = self.querySelector('script[type="application/json"][data-cfon-stores]');
        if (inline) {
          payload = JSON.parse(inline.textContent || '[]');
        } else {
          if (!self.storesUrl) throw new Error('cfon-stores-url-missing');
          var response = await fetch(self.storesUrl, { signal: self.abort.signal });
          if (!response.ok) throw new Error('cfon-stores-fetch-failed');
          payload = await response.json();
        }

        if (!Array.isArray(payload)) throw new Error('cfon-stores-invalid');

        var normalized = [];
        var dropped = 0;
        for (var i = 0; i < payload.length; i++) {
          var store = normalizeStore(payload[i], i);
          if (!store) {
            dropped += 1;
            continue;
          }
          if (store.lat == null || store.lng == null) {
            dropped += 1;
            continue;
          }
          normalized.push(store);
        }

        if (dropped > 0) {
          console.warn('[cfon-store-locator] dropped ' + dropped + ' store rows (missing or invalid coordinates)');
          if (window.Shopify && Shopify.designMode) {
            var note = self.querySelector('[data-editor-note]');
            if (!note) {
              note = document.createElement('p');
              note.className = 'cfon-store-locator__editor-note';
              note.setAttribute('data-editor-note', '');
              self.prepend(note);
            }
            note.textContent =
              'Dropped ' + dropped + ' store rows with missing or invalid coordinates. Check lat/lng in the data source.';
          }
        }

        self.stores = normalized;
        return self.stores;
      })();
      return this.storesPromise;
    }

    async onSubmit(event) {
      event.preventDefault();
      if (this.loading || this.destroyed) return;
      var query = this.input ? this.input.value.trim() : '';
      if (!query) return;

      this.setLoading(true);
      this.setState('loading');
      this.announce(this.strSearching);

      try {
        await Promise.all([ensureMaps(this.apiKey), this.loadStores()]);
        if (this.destroyed || !this.isConnected) return;
        if (!window.google || !window.google.maps) throw new Error('cfon-maps-unavailable');

        this.geocoder = this.geocoder || new google.maps.Geocoder();
        var result = await geocodePromise(this.geocoder, {
          address: query,
          componentRestrictions: { country: this.country },
        });
        if (this.destroyed || !this.isConnected) return;

        var location = result.geometry.location;
        this.center = { lat: location.lat(), lng: location.lng() };
        this.search(this.center);
      } catch (error) {
        if (this.destroyed || !this.isConnected) return;
        if (error && error.code === 'ZERO_RESULTS') {
          this.showEmpty(this.strNoMatch, '');
          return;
        }
        this.showError(this.strErrorTitle, this.strErrorBody);
      } finally {
        if (!this.destroyed && this.isConnected) this.setLoading(false);
      }
    }

    async onGeoClick(event) {
      event.preventDefault();
      if (this.loading || this.destroyed) return;
      if (!navigator.geolocation) {
        this.showError(this.strErrorTitle, this.strGeoDenied);
        return;
      }

      this.setLoading(true);
      this.setState('loading');
      this.announce(this.strLocating);

      var self = this;
      try {
        var position = await new Promise(function (resolve, reject) {
          navigator.geolocation.getCurrentPosition(resolve, reject, {
            timeout: 10000,
            maximumAge: 300000,
          });
        });
        if (this.destroyed || !this.isConnected) return;

        await Promise.all([ensureMaps(this.apiKey), this.loadStores()]);
        if (this.destroyed || !this.isConnected) return;
        if (!window.google || !window.google.maps) throw new Error('cfon-maps-unavailable');

        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
        this.search(this.center);
      } catch (error) {
        if (this.destroyed || !this.isConnected) return;
        this.showError(this.strErrorTitle, this.strGeoDenied);
      } finally {
        if (!this.destroyed && this.isConnected) this.setLoading(false);
      }
    }

    search(center) {
      var radius = this.radius;
      var ranked = this.stores
        .map(function (store) {
          var miles = haversine(center.lat, center.lng, store.lat, store.lng);
          return Object.assign({}, store, { distance: miles });
        })
        .filter(function (store) {
          return store.distance <= radius;
        })
        .sort(function (a, b) {
          if (a.distance !== b.distance) return a.distance - b.distance;
          return String(a.id).localeCompare(String(b.id));
        });

      this.results = ranked;
      this.visible = Math.min(this.perPage, ranked.length);
      this.activeIndex = ranked.length ? 0 : -1;

      if (!ranked.length) {
        this.showEmpty(this.emptyTitle || this.strNoResults, this.emptyBodyText);
        return;
      }

      this.setState('results');
      this.render();
      this.announce(this.formatCount(ranked.length));
      this.focusHeading(this.resultsHeading);
    }

    formatCount(count) {
      var template = count === 1 ? this.strCountOne : this.strCountOther;
      return template.replace('%%', String(count));
    }

    formatDistance(miles) {
      var rounded = miles < 10 ? miles.toFixed(1) : String(Math.round(miles));
      return this.strDistance.replace('%%', rounded);
    }

    showEmpty(title, body) {
      this.setState('empty');
      if (this.emptyHeading && title) {
        // Keep Figma split lead/accent spans for default empty title.
        var hasSplit =
          this.emptyHeading.querySelector('.cfon-store-locator__fallback-title-lead') &&
          this.emptyHeading.querySelector('.cfon-store-locator__fallback-title-accent');
        if (!hasSplit || (title && title !== this.emptyTitle && title !== this.strNoResults)) {
          this.emptyHeading.textContent = title;
        }
      }
      if (this.emptyBody) this.emptyBody.textContent = body || '';
      this.announce(title || this.strNoResults);
      this.focusHeading(this.emptyHeading);
      if (!this.center) this.center = { lat: 40.7359, lng: -73.9911 };
      this.mountMap([]);
    }

    showError(title, body) {
      this.setState('error');
      if (this.errorHeading && title) this.errorHeading.textContent = title;
      if (this.errorBody) this.errorBody.textContent = body || this.strErrorBody;
      this.announce(title || this.strErrorTitle);
      this.focusHeading(this.errorHeading);
      if (!this.center) this.center = { lat: 40.7359, lng: -73.9911 };
      this.mountMap([]);
    }

    mountMap(shown) {
      var self = this;
      if (!this.apiKey) return;
      ensureMaps(this.apiKey)
        .then(function () {
          if (self.destroyed || !self.isConnected) return;
          if (!window.google || !window.google.maps) return;
          self.renderMarkers(shown || []);
        })
        .catch(function () {});
    }

    onShowMore() {
      if (!this.results.length) return;
      var prev = this.visible;
      this.visible = Math.min(this.visible + this.perPage, this.results.length);
      this.render();
      if (this.visible >= this.results.length) {
        var firstNew = this.list && this.list.children[prev];
        var btn = firstNew && firstNew.querySelector('[data-store-btn]');
        if (btn) btn.focus();
      }
    }

    onListClick(event) {
      var btn = event.target.closest('[data-store-btn]');
      if (!btn || !this.list.contains(btn)) return;
      var item = btn.closest('[data-store-item]');
      if (!item) return;
      var index = Number(item.dataset.index);
      if (!Number.isFinite(index)) return;
      this.setActive(index, { scrollList: false, panMap: true });
    }

    setActive(index, options) {
      options = options || {};
      if (index < 0 || index >= this.visible) return;
      this.activeIndex = index;
      var items = this.list ? this.list.querySelectorAll('[data-store-item]') : [];
      for (var i = 0; i < items.length; i++) {
        var active = i === index;
        items[i].classList.toggle('cfon-store-locator__item--active', active);
        if (active) items[i].setAttribute('aria-current', 'true');
        else items[i].removeAttribute('aria-current');
      }

      var store = this.results[index];
      if (this.map && store) {
        var latLng = { lat: store.lat, lng: store.lng };
        if (this.reducedMotion()) this.map.setCenter(latLng);
        else this.map.panTo(latLng);
      }

      if (options.scrollList && items[index]) {
        items[index].scrollIntoView({
          block: 'nearest',
          behavior: this.reducedMotion() ? 'auto' : 'smooth',
        });
      }
    }

    render() {
      if (!this.list || !this.template) return;
      var shown = this.results.slice(0, this.visible);
      var frag = document.createDocumentFragment();

      for (var i = 0; i < shown.length; i++) {
        var store = shown[i];
        var node = this.template.content.firstElementChild.cloneNode(true);
        node.dataset.index = String(i);

        var nameEl = node.querySelector('[data-store-name]');
        var addressEl = node.querySelector('[data-store-address]');
        var cityLineEl = node.querySelector('[data-store-city-line]');
        var distanceEl = node.querySelector('[data-store-distance]');
        var directions = node.querySelector('[data-store-directions]');
        var directionsLabel = node.querySelector('[data-store-directions-label]');
        var directionsA11y = node.querySelector('[data-store-directions-a11y]');

        if (nameEl) nameEl.textContent = store.name;
        if (addressEl) addressEl.textContent = store.address;
        if (cityLineEl) {
          cityLineEl.textContent = [store.city, store.state, store.zip].filter(Boolean).join(', ');
        }
        if (distanceEl) distanceEl.textContent = this.formatDistance(store.distance);

        var dest = [store.address, store.city, store.state, store.zip].filter(Boolean).join(', ');
        if (!dest) dest = store.lat + ',' + store.lng;
        if (directions) {
          directions.href =
            'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(dest);
        }
        if (directionsLabel) directionsLabel.textContent = this.strGetDirections;
        if (directionsA11y) {
          directionsA11y.textContent = this.strDirectionsFor.replace('%%', store.name);
        }

        if (i === this.activeIndex) {
          node.classList.add('cfon-store-locator__item--active');
          node.setAttribute('aria-current', 'true');
        }

        frag.appendChild(node);
      }

      this.list.replaceChildren(frag);

      if (this.resultsCount) {
        this.resultsCount.hidden = false;
        this.resultsCount.textContent = this.formatCount(this.results.length);
      }

      if (this.moreBtn) {
        var hasMore = this.visible < this.results.length;
        this.moreBtn.hidden = !hasMore;
      }

      this.renderMarkers(shown);
    }

    clearMarkers() {
      for (var i = 0; i < this.markers.length; i++) {
        this.markers[i].setMap(null);
      }
      this.markers = [];
    }

    renderMarkers(shown) {
      if (!this.mapEl || !window.google || !window.google.maps) return;

      if (!this.map) {
        this.map = new google.maps.Map(this.mapEl, {
          center: this.center || { lat: 40.7359, lng: -73.9911 },
          zoom: 12,
          mapTypeControl: false,
          streetViewControl: false,
          fullscreenControl: false,
          styles: [
            { elementType: 'geometry', stylers: [{ color: '#212121' }] },
            { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
            { elementType: 'labels.text.fill', stylers: [{ color: '#757575' }] },
            { elementType: 'labels.text.stroke', stylers: [{ color: '#212121' }] },
            { featureType: 'administrative', elementType: 'geometry', stylers: [{ color: '#757575' }] },
            { featureType: 'poi', elementType: 'labels.text.fill', stylers: [{ color: '#757575' }] },
            { featureType: 'poi.park', elementType: 'geometry', stylers: [{ color: '#181818' }] },
            { featureType: 'road', elementType: 'geometry.fill', stylers: [{ color: '#2c2c2c' }] },
            { featureType: 'road', elementType: 'labels.text.fill', stylers: [{ color: '#8a8a8a' }] },
            { featureType: 'road.arterial', elementType: 'geometry', stylers: [{ color: '#373737' }] },
            { featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: '#3c3c3c' }] },
            { featureType: 'transit', elementType: 'geometry', stylers: [{ color: '#2f2f2f' }] },
            { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#000000' }] },
            { featureType: 'water', elementType: 'labels.text.fill', stylers: [{ color: '#3d3d3d' }] },
          ],
        });
      }

      this.clearMarkers();
      if (!shown.length) {
        if (this.center) {
          this.map.setCenter(this.center);
          this.map.setZoom(12);
        }
        return;
      }
      var bounds = new google.maps.LatLngBounds();
      var self = this;

      for (var i = 0; i < shown.length; i++) {
        (function (index, store) {
          var marker = new google.maps.Marker({
            map: self.map,
            position: { lat: store.lat, lng: store.lng },
            title: store.name,
            optimized: false,
          });
          marker.addListener('click', function () {
            self.setActive(index, { scrollList: true, panMap: true });
          });
          self.markers.push(marker);
          bounds.extend(marker.getPosition());
        })(i, shown[i]);
      }

      if (shown.length === 1) {
        this.map.setCenter(bounds.getCenter());
        this.map.setZoom(14);
      } else if (shown.length > 1) {
        this.map.fitBounds(bounds, 48);
      }
    }
  }

  CfonElements.define('cfon-store-locator', CfonStoreLocator);
})();
